module.exports = __webpack_public_path__ + "img/1.d97f8615.png";